<div fxLayout="column" fxLayoutAlign="start start" class="footer_header">
	<span
		i18n="@@footer_label_features"
		class="footer-titles mat-headline-6 features p-l-xs"
		*ngIf="showFeaturesHeader"
	>
		Features
	</span>
	<a
		i18n="@@footer_label_globalFundraising"
		[href]="globalHref"
		class="global break-word"
		style="cursor: pointer"
	>
		Global Fundraising
	</a>
	<a
		i18n="@@footer_label_customBranding"
		[href]="customHref"
		class="custom break-word"
		style="cursor: pointer"
	>
		Custom Branding
	</a>
	<a
		i18n="@@footer_label_recurringDonations"
		[href]="recurringHref"
		class="recurring break-word"
		style="cursor: pointer"
	>
		Recurring Donations
	</a>
	<a
		i18n="@@footer_label_qrCodeAndPaymentRequest"
		[href]="donationHref"
		class="qr-code break-word"
		style="cursor: pointer"
	>
		QR-Code & Payment Request
	</a>
	<a
		i18n="@@online_fundraising_features_peerToPeerFundraisingHomeOrganization"
		[href]="peerHref"
		class="peerToPeer break-word"
		style="cursor: pointer"
	>
		Peer-To-Peer Fundraising</a
	>
</div>
